import type { Site } from "../../../../utils/backend-types";

export function getSiteTitle(site: Site) {
  return `${site.name} (${site.id})`;
}
